import { SegmentedToggle, type SegmentedOption } from '../../virtual-appointments/SegmentedToggle';
import type { AppointmentsView } from './appointmentsOverlayParams';

const VIEW_OPTIONS: readonly SegmentedOption<AppointmentsView>[] = [
    { value: 'practice', label: 'Practice' },
    { value: 'virtual', label: 'Virtual' }
];

interface AppointmentsViewToggleProps {
    value: AppointmentsView;
    onChange: (view: AppointmentsView) => void;
}

export function AppointmentsViewToggle({ value, onChange }: AppointmentsViewToggleProps) {
    return (
        <div className="shrink-0">
            <SegmentedToggle<AppointmentsView>
                value={value}
                options={VIEW_OPTIONS}
                onChange={onChange}
                ariaLabel="Appointments view"
            />
        </div>
    );
}
